import { useContext } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";

import UseFullDataContext from "../../../context/UseFullData";

import {
  CustomInput,
  ReactSelect,
  FileInputSecond,
} from "../../kits/Inputs/Inputs";
import ColorSchema from "../../kits/Color";
import { TrashIcon } from "../../kits/Icons";
import PreviewImage from "./PreviewImage";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

export default function FinalProductDetail({
  data,
  changeFirstTabData,
  setBodyText,
  bodyTxt,
  addOrEdit,
}) {
  const { priceType } = useContext(UseFullDataContext);
  return (
    <div className="d-flex flex-wrap w-100 align-items-center final-product-detail">
      <div className="w-100 my-1 d-flex flex-wrap">
        {addOrEdit != "edit" && (
          <div className="col-12 col-sm-3 my-1 px-1">
            <FileInputSecond
              id="add-new-video-single-product"
              label="اپلود ویدئو"
              onChangeFunc={(e) => {
                changeFirstTabData(e.target.value, "video");
              }}
              multiple={false}
              accept="video/mp4,video/x-m4v,video/mkv,video/*"
            />
          </div>
        )}
        <div className="col-12 col-sm-9 px-1">
          <CustomInput
            label="لینک (آپارات)"
            inputSize="lg"
            type="text"
            inputType="input"
            inputContainer=""
            inputClassName=""
            activate={addOrEdit == "edit" ? "disabled" : ""}
            inputValue={data?.link}
            onChangeFunc={(e) => changeFirstTabData(e.target.value, "link")}
            // textErr={validationTxt.answers}
          />
        </div>
      </div>
      <div className="w-100 my-1">
        <label>توضیحات بلند</label>
        <SunEditor
          disable={addOrEdit == "edit" ? true : false}
          onChange={(content) => {
            setBodyText(content);
          }}
          setContents={bodyTxt}
          setOptions={{
            buttonList: [
              ["font", "fontSize", "formatBlock"],
              [
                "bold",
                "underline",
                "italic",
                "strike",
                "subscript",
                "superscript",
              ],
              ["align", "horizontalRule", "list", "table"],
              ["fontColor", "hiliteColor"],
              ["outdent", "indent"],
              ["undo", "redo"],
              ["removeFormat"],
              ["outdent", "indent"],
              ["link"],
              ["preview", "print"],
              ["fullScreen", "showBlocks", "codeView"],
            ],
          }}
        />
        {/* <CustomInput
          label="توضیحات بلند"
          inputSize="lg"
          type="text"
          inputType="textarea"
          inputContainer=""
          inputClassName=""
          inputValue={data?.bodytxt}
          onChangeFunc={(e) => changeFirstTabData(e.target.value, "bodytxt")}
          // textErr={validationTxt.answers}
        /> */}
      </div>
      <div className="col-6 col-sm-3 my-1 px-1">
        <CustomInput
          label="میزان تغییر قیمت"
          inputSize="lg"
          type="text"
          inputContainer=""
          inputClassName=""
          activate={addOrEdit == "edit" ? "disabled" : ""}
          inputValue={addCommas(data?.benefit_value)}
          onChangeFunc={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              changeFirstTabData(removeCommas(e.target.value), "benefit_value");
          }}
        />
      </div>
      <div className="col-6 col-sm-3 mb-1 px-1" style={{ marginTop: 6 }}>
        <ReactSelect
          title="نوع تغییر قیمت"
          itemsList={priceType}
          inputContainer=""
          inputSize="lg"
          inputValue={data?.benefit_type}
          activate={addOrEdit == "edit" ? false : true}
          onChangeFunc={(e) => {
            changeFirstTabData(e, "benefit_type");
          }}
          textErr={""}
        />
      </div>
      <div className="col-6 col-sm-3 my-1 px-1">
        <CustomInput
          label="میزان تخفیف"
          inputSize="lg"
          type="nummber"
          inputContainer=""
          activate={addOrEdit == "edit" ? "disabled" : ""}
          inputClassName=""
          inputValue={addCommas(data?.discount)}
          onChangeFunc={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              changeFirstTabData(removeCommas(e.target.value), "discount");
          }}
        />
      </div>
      <div className="col-6 col-sm-3 mb-1 px-1" style={{ marginTop: 6 }}>
        <ReactSelect
          title="نوع تخفیف"
          itemsList={priceType}
          inputContainer=""
          inputSize="lg"
          inputValue={data?.discount_type}
          activate={addOrEdit == "edit" ? false : true}
          onChangeFunc={(e) => {
            changeFirstTabData(e, "discount_type");
          }}
          textErr={""}
        />
      </div>
      <div className="col-6 col-sm-3 mb-1 px-1" style={{ marginTop: 6 }}>
        <div className="d-flex justify-content-between">
          <label style={{ marginBottom: "0.5rem" }}>محدودیت تخفیف</label>

          {addOrEdit != "edit" && (
            <div
              onClick={() => {
                changeFirstTabData("", "endDiscount");
              }}
            >
              <TrashIcon
                containerIconClassName="cursor-pointer"
                color={`${ColorSchema.danger_custom}`}
                width={20}
                height={20}
              />
            </div>
          )}
        </div>
        <DatePicker
          value={data?.endDiscount}
          disabled={addOrEdit == "edit" ? true : false}
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          onChange={(e) => {
            changeFirstTabData(e, "endDiscount");
          }}
        />
      </div>
    </div>
  );
}
